import React from 'react';
import { TargetIcon } from '../icons/InterfaceIcons';

export const QuickPracticeCard = () => {
    return (
        <div className="bg-brand-surface border border-brand-border rounded-xl p-6 flex flex-col h-full shadow-card">
             <div className="flex items-center justify-between mb-4">
                <h3 className="font-bold text-xl text-brand-text-primary">Quick Practice</h3>
                <TargetIcon className="w-6 h-6 text-brand-text-secondary" />
            </div>
            <div className="flex-grow">
                <p className="text-brand-text-secondary mb-2 text-sm">Pick a chapter to begin.</p>
                <select
                    className="block w-full pl-3 pr-10 py-2.5 text-base border border-brand-border focus:outline-none focus:ring-brand-primary focus:border-brand-primary sm:text-sm rounded-md bg-brand-surface text-brand-text-primary cursor-pointer"
                >
                    <option>Physics - Electrostatics</option>
                    <option>Chemistry - Thermodynamics</option>
                    <option>Maths - Integration</option>
                    <option>Biology - Genetics</option>
                </select>
            </div>
             <button className="mt-4 w-full bg-brand-secondary hover:bg-brand-secondary-hover text-white font-bold py-2.5 px-4 rounded-lg transition-colors cursor-pointer">
                Start Practice
            </button>
        </div>
    );
};